module.exports = __webpack_public_path__ + "generic-ic.svg?073912638fb7eec3d3178e727eaf52fe";